<template>
  <div>
    <!-- Input field yang terformat -->
    <input
      :value="formattedValue"
      @input="onInputChange"
      placeholder="Masukkan saldo"
    />
    <p style="color: gray; font-size: 0.8em;">
      The entered balance will set the limit for receiving notifications
    </p>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    // Menggunakan computed untuk menampilkan nilai yang terformat
    formattedValue() {
      return this.value.toLocaleString('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
      }).replace('IDR', 'Rp').trim();
    },
  },
  methods: {
    // Menangani perubahan input
    onInputChange(event) {
      // Mengambil hanya angka dari input
      const cleanedValue = event.target.value.replace(/[^\d]/g, '');

      // Emit nilai yang sudah dibersihkan ke parent
      this.$emit('input', parseInt(cleanedValue, 10) || 0);
    },
  },
};
</script>

<style scoped>
input {
  font-size: 16px;
  border: none;
  border-bottom: 1px solid #ccc;
  outline: none;
  width: 100%;
  padding: 5px;
}
</style>
